import { render, staticRenderFns } from "./transactionDetails.vue?vue&type=template&id=35e5a120&scoped=true&"
import script from "./transactionDetails.vue?vue&type=script&lang=js&"
export * from "./transactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./transactionDetails.vue?vue&type=style&index=0&id=35e5a120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5a120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35e5a120', component.options)
    } else {
      api.reload('35e5a120', component.options)
    }
    module.hot.accept("./transactionDetails.vue?vue&type=template&id=35e5a120&scoped=true&", function () {
      api.rerender('35e5a120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/transactionDetails.vue"
export default component.exports